/**
 * Created by shubham on 11/4/18.
 */

import {AdminPage} from "./admin-page";

/**
 * An array of data with an associated page object used for paging
 */
export class AdminPageData<T> {
    data = new Array<T>();
    page = new AdminPage();
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-dashboard/admin-datatable/admin-page-data.ts